export default __webpack_public_path__ + "7ff164afd03de1fc7a63582770a2927b.png";